import React, { useState, useRef } from "react";
import { Container, Input, Select } from "../styled.ts";
import { debounce } from "../../utils/debounce.js";
import { CrossIcon, SearchIcon, FilterIcon } from "../icons/index.tsx";

export const Search = ({
  categories = ["all"],
  placeholder = "enter something",
  padding = "2px 3px",
  onChange = (val) => {
    console.log(val);
  },
}) => {
  const DELAY = 500;
  const [searchKey, setSearchKey] = useState({
    category: "All",
    searchWord: "",
  });
  const debouncedOnChange = debounce(onChange, DELAY);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const selectRef = useRef(null);

  return (
   <> <span ref={selectRef} style={{position:"absolute",visibility:"hidden"}}></span>

    <Container
      padding={padding}
      border="1px solid #EEEEEE"
      radius="100px"
      background="#FAFAFA"
      alignItems="center"
      gap={"5px"}
      width={"100%"}
    >
      <Select
        color="#828282"
        style={{maxWidth:"40%", textOverflow: "ellipsis"}}
        onChange={(e) => {
          debouncedOnChange({ ...searchKey, category: e.target.value });
          setSearchKey({ ...searchKey, category: e.target.value });
          selectRef.current.innerText = e.target.value;
          e.target.style.width = `${selectRef.current.offsetWidth+20}px`
          e.target.title = e.target.value
        }}

      >
        {categories.map((category) => (
          <option
            key={category}
            default={category === searchKey.category}
            value={category}
          >
            {category}
          </option>
        ))}
      </Select>
      <Container
        border="solid 0.25px #eee"
        height="40px"
      ></Container>
      <Input
        style={{ flex: "1" , textOverflow: "ellipsis"}}
        minWidth={"100px"}
        type="text"
        placeholder={placeholder}
        border="none"
        value={searchKey.searchWord}
        height={"48px"}
        color="#828282"
        onChange={(e) => {
          debouncedOnChange({ ...searchKey, searchWord: e.target.value });
          setSearchKey({ ...searchKey, searchWord: e.target.value });
        }}
      />

      <Container padding="14px" style={{cursor:"pointer"}}>
        {!!searchKey.searchWord ? (
          <CrossIcon
            width="20"
            height="20"
            color={"#828282"}
            onClick={() => {
              const resetData = { ...searchKey, searchWord: "" };
              onChange(resetData);
              setSearchKey(resetData);
            }}
          />
        ) : (
          <SearchIcon
            width="20"
            height="20"
            color={"#828282"}
            onClick={() => {
              setIsFilterActive(!isFilterActive);
            }}
          />
        )}
      </Container>
    </Container>
    </>
  );
};
